import React, { useEffect, useState } from 'react';
import Apiservice from '../Apiservice';
import { useNavigate } from 'react-router-dom';
import OverAllAttendancePDF from './DayAttendancePDF';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Modal, Button } from "react-bootstrap";
import { formatDateTimeAuto, formatDateTime, calculateWorkingHours, } from '../Utils/Utils';
import { findNearestSite } from '../Utils/locationUtils';
import Swal from "sweetalert2";
import { formatDate } from 'date-fns';


const Attendance = () => {
    const navigate = useNavigate();
    const [originalRoleId, setOriginalRoleId] = useState(0);
    const [roleIdByUser, setRoleIdByUser] = useState(originalRoleId);
    const [userId, setUserId] = useState(0);
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [workingTime, setWorkingTime] = useState("00:00:00");
    const [timerId, setTimerId] = useState(null);

    const [loading, setLoading] = useState(false);
    const [attendanceDetails, setAttendanceDetails] = useState([]);

    const [roles, setRoles] = useState([]);
    const [sites, setSites] = useState([]);
    const [presentUsers, setPresentUsers] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const [siteIdByStaff, setSiteIdByStaff] = useState(0);
    const [dutyTypes, setDutyTypes] = useState([]);
    const [dutyTypeId, setDutyTypeId] = useState(0);
    //const [dutyName, setDutyName] = useState('');

    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const roleId = localStorage.getItem("role_id");
        const userId = localStorage.getItem("user_id");

        setOriginalRoleId(roleId ? Number(roleId) : 0);
        setUserId(userId ? Number(userId) : 0);
    }, []);


    useEffect(() => {
        if (originalRoleId !== 1) {
            loadAllAttendanceData();

            AttendancePageByUser();

            // const interval = setInterval(() => {
            //     const now = new Date();
            //     setTime(now.toLocaleTimeString('en-GB', { hour12: false }));
            // }, 1000);

            // return () => clearInterval(interval); // Cleanup on unmount
        }

        const isAdmin = originalRoleId === 1 || originalRoleId === "1";
        if (!isAdmin) return; // 🔥 ADMIN ONLY
        const id = setInterval(() => {
            setNow(Date.now());
        }, 1000);

        return () => clearInterval(id);
    }, [originalRoleId]);

    const AttendancePageByUser = async () => {
        let result = await Apiservice.AttendancePageByUser();
        if (result.success) {
            setDutyTypes(result.data.dutyTypes);
            setRoles(result.data.roles)
        }
        else {
            alert("Error in Duty Types")
        }
    };

    const convertDateFormat = (dateString) => {
        const [day, month, year] = dateString.split('/');
        return `${year}-${month}-${day}`;
    };

    //retrived Data
    const loadAllAttendanceData = async () => {
        const role_id = Number(localStorage.getItem('role_id'));
        setOriginalRoleId(role_id);

        const id = localStorage.getItem('user_id') || 0;
        setUserId(id);

        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const day = currentDate.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setDate(`${day}/${month}/${year}`);

        const entryDateFormatted = `${year}-${month}-${day}`;

        let assignData = {
            //  userId: id,
            entryTime: entryDateFormatted,
            includeOpenAttendance: true,
            include24HoursAttendance: true,
            status: 0
        };

        const assignResult = await Apiservice.AttendanceAssign(assignData);
        if (assignResult.success) {
            setRoles(assignResult.data?.roles || []);
            setSites(assignResult.data?.sites || []);
            setPresentUsers(assignResult.data?.presentUsers || []);
        }

        let attendanceData = {
            userId: id,
            entryTime: entryDateFormatted,
            includeOpenAttendance: true,
            include24HoursAttendance: true,
            status: 0
        };

        const attendanceResult = await Apiservice.GetAttendanceByEntryDate(attendanceData);
        console.log("attendanceResult", attendanceResult)
        if (attendanceResult.success) {
            setAttendanceDetails(attendanceResult.data || []);
        }
        else {
            setAttendanceDetails([]);
        }
    };

    //for admin page
    useEffect(() => {
        setUserId(localStorage.getItem('user_id') || 0)
        const currentDate = new Date();
        // Extract year, month, and day
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed, so add 1
        const day = currentDate.getDate().toString().padStart(2, '0'); // Pad with leading zero if needed

        const formattedDate = `${year}-${month}-${day}`;
        //  setDate(`${day}-${month}-${year}`)
        let data = {
            //'userId': userId,
            "entryTime": formattedDate,
            "includeOpenAttendance": true,
            "status": 0
        }
        const fetchData = async () => {
            let result = await Apiservice.AttendanceAssign(data);
            if (result.success === true) {
                setRoles(result.data?.roles);
                setSites(result.data?.sites);
                setPresentUsers(result.data?.presentUsers);
                setLoading(false);
            }
        }
        fetchData();
    }, []);

    useEffect(() => {
        if (userId > 1) {
            const fetchData = async () => {
                let data = {
                    user_id: userId,
                    status: 0
                }
                const token = localStorage.getItem("access_token");
                const headers = { access_token: token };
                let result = await Apiservice.GetUserById(data, headers);
                if (result.success === true) {
                    let retrievedData = result.data;
                    setSiteIdByStaff(retrievedData[0].site_id);
                } else {
                    alert(result.message);
                }
            };
            fetchData();
        }
    }, [userId]);

    useEffect(() => {
        const fetchData = async () => {
            if (!userId) return;
            //const role_id = localStorage.getItem('role_id');
            // setRoleId(role_id);

            const formattedDate = convertDateFormat(date);
            let data = {
                userId: userId,
                entryTime: formattedDate,
                includeOpenAttendance: true,
                status: 0
            };

            let result = await Apiservice.GetAttendanceByEntryDate(data);
            console.log("result/data", result)
            if (result.success === true) {
                startWorkingTimer(result.data[0].entryTime);
                setAttendanceDetails(result.data);
            }
        };

        fetchData();
    }, [userId, date]);

    const handleCheckIn = async () => {
        if (!roleIdByUser || roleIdByUser === "0") {
            Swal.fire({
                icon: "warning",
                title: "Grade Required",
                text: "Please select your grade before check-in",
                confirmButtonColor: "#0d6efd",
            });
            return;
        }
        if (!dutyTypeId || dutyTypeId === "0") {
            Swal.fire({
                icon: "warning",
                title: "Duty Required",
                text: "Please select your duty before check-in",
                confirmButtonColor: "#0d6efd",
            });
            return;
        }
        if (!navigator.geolocation) {
            alert("Geolocation not supported.");
            return;
        }

        setLoading(true);

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;

                let entryTime = new Date().toISOString();

                let finalSiteId = siteIdByStaff; // 👈 default

                // 🔹 IF site not assigned → auto detect by GPS
                if (siteIdByStaff == 0) {
                    let result = await Apiservice.AllSites({ status: 0 });
                    let sites = result.data;

                    const matchedSite = findNearestSite(latitude, longitude, sites);

                    if (!matchedSite) {
                        setLoading(false);
                        alert("You are not within 2 KM of any site");
                        return;
                    }

                    finalSiteId = matchedSite.id; // ✅ auto assigned
                }

                const formData = new FormData();
                if (originalRoleId !== 1) {
                    formData.append("site_id", finalSiteId);
                    formData.append("user_id", userId);
                    if (originalRoleId !== roleIdByUser) {
                        formData.append('role_id', roleIdByUser)
                    }
                    formData.append('dutyTypeId', dutyTypeId)
                    formData.append("entryLatitude", latitude);
                    formData.append("entryLongitude", longitude);
                    // formData.append("entryTime", entryTime);
                    formData.append("status", 0);
                }

                const result = await Apiservice.CheckInAttendance(formData);
                setLoading(false);

                if (result.success) {
                    await Swal.fire({
                        icon: "success",
                        title: "Checked In",
                        text: "Checked in successfully!",
                        timer: 2000,
                        showConfirmButton: false
                    });

                    // 🔥 store UTC entry time
                    localStorage.setItem("attendanceEntryTime", new Date().toISOString());

                    startWorkingTimer(new Date().toISOString());

                    localStorage.setItem("siteId", finalSiteId);
                    window.dispatchEvent(new Event("siteIdChanged"));

                    await loadAllAttendanceData();
                }

                else {
                    alert(result.message);
                }
            },
            (error) => {
                setLoading(false);
                alert("Failed to get location.");
                console.error(error);
            }
        );
    };

    const startWorkingTimer = (entryTimeUtc) => {
        if (!entryTimeUtc || timerId) return; // 🔥 avoid duplicate timers

        const entry = new Date(entryTimeUtc).getTime();

        const id = setInterval(() => {
            const now = Date.now();
            const diffMs = now - entry;

            if (diffMs < 0) return;

            const totalSeconds = Math.floor(diffMs / 1000);

            const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
            const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
            const seconds = String(totalSeconds % 60).padStart(2, "0");

            setWorkingTime(`${hours}:${minutes}:${seconds}`);
        }, 1000);

        setTimerId(id);
    };

    useEffect(() => {
        const savedEntryTime = localStorage.getItem("attendanceEntryTime");

        if (savedEntryTime) {
            startWorkingTimer(savedEntryTime);
        }

        return () => stopWorkingTimer();
    }, []);

    const getRunningTime = (entryTimeUtc) => {
        if (!entryTimeUtc) return "00:00:00";

        const entry = new Date(entryTimeUtc).getTime();
        const diffMs = now - entry;

        if (diffMs < 0) return "00:00:00";

        const totalSeconds = Math.floor(diffMs / 1000);

        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
        const seconds = String(totalSeconds % 60).padStart(2, "0");

        return `${hours}:${minutes}:${seconds}`;
    };

    const getWorkingSeconds = (entryTime, exitTime) => {
        if (!entryTime) return 0;

        const start = new Date(entryTime).getTime();
        const end = exitTime
            ? new Date(exitTime).getTime()
            : Date.now();

        return Math.floor((end - start) / 1000);
    };

    const formatSeconds = (totalSeconds) => {
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
        const seconds = String(totalSeconds % 60).padStart(2, "0");

        return `${hours}:${minutes}:${seconds}`;
    };
    // const ALERT_SECONDS = (12 * 3600) + (30 * 60); // 45000 seconds
    const ALERT_SECONDS = (12 * 60 * 60) + (15 * 60);

    const handleCheckOut = async (attendanceId) => {
        if (!navigator.geolocation) {
            alert("Geolocation not supported.");
            return;
        }

        setLoading(true);

        navigator.geolocation.getCurrentPosition(async (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            // const exitTime = new Date().toISOString();
            const exitTime = new Date().toISOString();

            const formData = new FormData();
            formData.append('user_id', userId);
            formData.append('attendanceId', attendanceId);
            formData.append('exitLatitude', latitude);
            formData.append('exitLongitude', longitude);
            formData.append('exitTime', exitTime);
            formData.append('status', 0);

            const result = await Apiservice.CheckOutAttendance(formData);
            setLoading(false);


            if (result.success) {
                alert("Checked out successfully!");

                stopWorkingTimer();

                localStorage.removeItem("attendanceEntryTime");
                localStorage.removeItem("siteId");

                // 🔥 FORCE reload attendance data
                await loadAllAttendanceData(); // pass force flag

                // optional: notify other components
                window.dispatchEvent(
                    new CustomEvent("attendanceUpdated", {
                        detail: { refresh: true }
                    })
                );
            }


            else {
                alert(result.message);
            }
        }, (error) => {
            setLoading(false);
            alert("Failed to get location.");
            console.error(error);
        });
    };

    const stopWorkingTimer = () => {
        if (timerId) {
            clearInterval(timerId);
            setTimerId(null);
        }
    };

    const canReCheckIn = (exitTime) => {
        if (!exitTime) return false;

        const exit = new Date(exitTime).getTime();
        const now = Date.now();

        const TEN_HOURS = 10 * 60 * 60 * 1000;

        return now - exit >= TEN_HOURS;
    };

    useEffect(() => {
        if (
            attendanceDetails.length > 0 &&
            attendanceDetails[0].entryTime &&
            !attendanceDetails[0].exitTime
        ) {
            startWorkingTimer(attendanceDetails[0].entryTime);
        } else {
            stopWorkingTimer();
            setWorkingTime("00:00:00"); // optional reset
        }

        return () => stopWorkingTimer(); // cleanup
    }, [attendanceDetails]);

    const refreshAttendanceData = async () => {
        const formattedDate = convertDateFormat(date);
        let data = {
            entryTime: formattedDate,
            status: 0
        };

        let result = await Apiservice.AttendanceAssign(data);
        if (result.success === true) {
            setPresentUsers(result.data?.presentUsers);
        }
    }

    const handleSiteClick = async (id) => {
        navigate(`/sitedetails/${id}`)
    }

    const formatTime = (utcTime) => {
        if (!utcTime) return "";

        const date = new Date(utcTime); // ISO UTC string

        return date.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
            timeZone: "Asia/Kolkata"
        });
    };

    const handleEdit = async (userType, attendanceId) => {
        navigate('/staffattendanceedit', {
            state: { userType: userType, attendanceId: attendanceId, fromPage:'/attendance' }
        });
    }

    const handleFloaterAttendanceEdit = (fAttendanceId) => {
        navigate('/floaterattendanceedit', {
            state: { "fAttendanceId": fAttendanceId }
        })
    }

    const handleDeleteConfirm = async (attendanceId) => {
        const data = {
            'attendanceId': attendanceId,
            'status': 0
        };
        const token = localStorage.getItem("access_token");

        const headers = {
            access_token: token,
        };

        let result = await Apiservice.SoftDeleteAttendance(data);
        if (result.success === true) {
            setDeleteModal(false);
            setSelectedId(null); // Reset selected ID
            await loadAllAttendanceData(); // ✅ Refresh the data directly
        } else {
            alert(result.message);
        }
    };
    const handleCheckInButton = async () => {
        navigate('/staffattendance')
    }
    const handleApplyLeave = async () => {
        navigate('/leaveform')
    }
    const handleLeaveApplicationButton = async () => {
        navigate('/leaveapplicationlist')
    }
    // const blinkStyle = {
    //     animation: "blinkRed 1s infinite"
    // };

    const blinkStyle = {
        backgroundColor: "red"
    };

    return (

        <div className="container mt-1">
            <style>
                {`
@keyframes blinkRed {
    0%   { background-color: #ffcccc; }
    50%  { background-color: #ff0000; }
    100% { background-color: #ffcccc; }
}
`}
            </style>
            <style>
                {`
@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  70% { transform: scale(1.6); opacity: 0.4; }
  100% { transform: scale(1); opacity: 1; }
}
`}
            </style>

            {loading ? (
                <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                    <div className="text-center">
                        {/* Spinner with proper rotation */}
                        <div
                            className="spinner-border text-primary"
                            role="status"
                            style={{
                                width: "2rem",
                                height: "2rem",
                                borderWidth: "3px",
                            }}
                        >
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        {/* Minimalist Text */}
                        <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
                    </div>
                </div>
            ) :
                <>
                    {originalRoleId === 1 || originalRoleId === '1' ? (
                        <>{
                            sites.length > 0 && (
                                <>
                                    <div className="row">
                                        <div className="col">
                                            <h5>Sites</h5>
                                        </div>
                                    </div>
                                </>
                            )
                        }

                            <div className="row">
                                {sites.length > 0 && (
                                    sites.map((site, index) => (
                                        <div key={index} className="col-md-6 col-lg-4 mb-2">
                                            <div className="card shadow-sm h-100 border-0">
                                                <div className="card-body py-2 px-3">
                                                    <h5 className="card-title fw-bold text-primary mb-1">
                                                        <i className="bi bi-building"></i> {site.name}
                                                    </h5>
                                                    <hr />
                                                    {roles.length > 0 &&
                                                        roles
                                                            .filter(role => role.name !== "Super Admin") // Exclude Super Admin
                                                            .map((role, roleIndex) => {

                                                                // Find the matching role object from assignedStaffs
                                                                const matchedRole = site.assignedStaffs.find(
                                                                    staff => staff.roleName === role.name
                                                                );

                                                                const matchedRole1 = site.presentUsers.find(
                                                                    staff => staff.roleName === role.name
                                                                );
                                                                const matchRole2 = presentUsers.filter(
                                                                    presentUser =>
                                                                        presentUser.site_id === site.id &&
                                                                        presentUser.roleDetails &&
                                                                        presentUser.roleDetails.some(roleDetail => roleDetail.name === role.name)
                                                                );

                                                                const noOfStaff = matchedRole ? matchedRole.staffList.length : 0;
                                                                let noOfPresentStaff = matchedRole1 ? matchedRole1.staffList.length : 0;

                                                                if (matchRole2.length > 0 && noOfPresentStaff.id !== matchRole2.id) {
                                                                    noOfPresentStaff = noOfPresentStaff + matchRole2.length;
                                                                }
                                                                const isAbsentAlert = noOfStaff > 0 && noOfPresentStaff === 0;
                                                                return (
                                                                    <div
                                                                        key={roleIndex}
                                                                        onDoubleClick={() => handleSiteClick(site.id)}
                                                                        style={{
                                                                            marginBottom: "2px",
                                                                            padding: "2px 4px",
                                                                            borderRadius: "6px",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            backgroundColor: isAbsentAlert ? "#fff3f3" : "transparent",
                                                                            borderLeft: isAbsentAlert ? "4px solid #dc3545" : "4px solid transparent",
                                                                            transition: "0.3s"
                                                                        }}
                                                                    >

                                                                        {/* Role Name */}
                                                                        <div style={{ flex: 8, color: "#6c757d", fontWeight: 600, display: "flex", alignItems: "center" }}>

                                                                            {isAbsentAlert && (
                                                                                <span
                                                                                    style={{
                                                                                        width: "8px",
                                                                                        height: "8px",
                                                                                        backgroundColor: "#dc3545",
                                                                                        borderRadius: "50%",
                                                                                        marginRight: "6px",
                                                                                        animation: "pulse 1.2s infinite"
                                                                                    }}
                                                                                ></span>
                                                                            )}

                                                                            {role.name}
                                                                        </div>

                                                                        {/* Colon */}
                                                                        <div style={{ flex: 1, color: "#6c757d" }}>:</div>

                                                                        {/* Count */}
                                                                        <div style={{
                                                                            flex: 2,
                                                                            fontWeight: "bold",
                                                                            color: isAbsentAlert ? "#dc3545" : "#198754"
                                                                        }}>
                                                                            {`${noOfPresentStaff}/${noOfStaff}`}
                                                                        </div>

                                                                    </div>

                                                                );
                                                            })
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                            <div className="d-flex flex-wrap justify-content-end align-items-center gap-2 mb-2">

                                {sites.length > 0 && (
                                    <PDFDownloadLink
                                        document={<OverAllAttendancePDF presentUsers={presentUsers} sites={sites} />}
                                        fileName={`${date} attendance.pdf`}
                                        className="text-decoration-none"
                                    >
                                        {({ loading }) => (
                                            <button
                                                className="btn btn-success btn-sm px-3"
                                                disabled={loading}
                                            >
                                                {loading ? "Generating..." : "Download PDF"}
                                            </button>
                                        )}
                                    </PDFDownloadLink>
                                )}

                                <button
                                    className="btn btn-outline-primary btn-sm px-3"
                                    onClick={handleLeaveApplicationButton}
                                >
                                    Leave Application
                                </button>

                                <button
                                    className="btn btn-outline-primary btn-sm px-3"
                                    onClick={handleApplyLeave}
                                >
                                    Apply Leave
                                </button>

                                <button
                                    className="btn btn-primary btn-sm px-3"
                                    onClick={handleCheckInButton}
                                >
                                    Check In
                                </button>

                            </div>

                            <div className="card shadow p-4">
                                <h4 className="mb-4 text-center text-primary">Present Staff List</h4>
                                <div className="table table-responsive">
                                    <table className="table table-bordered table-responsive">
                                        <thead className="table-dark">
                                            <tr>
                                                <th>#</th>
                                                <th>Staff Id</th>
                                                <th>Name</th>
                                                <th>NRIC/FIN</th>
                                                <th>Grade</th>
                                                <th>Duty Type</th>
                                                <th>Contact No.</th>
                                                <th>Site</th>
                                                <th>Time In</th>
                                                <th>Work Hours</th>
                                                <th>Time Out</th>
                                                <th>Total Hours</th>
                                                <th>Time In Location</th>
                                                <th>Time Out Location</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {presentUsers.length > 0 ? (
                                                presentUsers.map((user, index) => {
                                                    const workedSeconds = getWorkingSeconds(
                                                        user.entryTime,
                                                        user.exitTime
                                                    );

                                                    const shouldBlink =
                                                        !user.exitTime && workedSeconds >= ALERT_SECONDS;
                                                    const blinkStyle = shouldBlink
                                                        ? {
                                                            backgroundColor:
                                                                Math.floor(now / 1000) % 2 === 0
                                                                    ? "#ff0000"
                                                                    : "#ffcccc",
                                                            color: "white"
                                                        }
                                                        : {};
                                                    const userDetails = user.userDetails;
                                                    console.log({
                                                        name: userDetails,
                                                        workedSeconds,
                                                        ALERT_SECONDS,
                                                        shouldBlink
                                                    });
                                                    return (
                                                        <tr
                                                            key={user.id ?? index}
                                                            style={{ backgroundColor: "red" }}
                                                        //   className={shouldBlink ? "blink-row" : ""}
                                                        >
                                                            <td style={blinkStyle}>{index + 1}</td>
                                                            <td style={blinkStyle}>{userDetails.id ? userDetails.id : '#'}</td>
                                                            <td style={blinkStyle}>
                                                                {
                                                                    userDetails.firstName ? userDetails.firstName + " " + userDetails.lastName : user.staffName
                                                                }
                                                            </td>
                                                            <td style={blinkStyle}> {userDetails.nricOrFin ? userDetails.nricOrFin : user.nricOrFin} </td>
                                                            <td style={blinkStyle}>{user.roleDetails?.[0]?.name ?? "-"}</td>
                                                            <td style={blinkStyle}>{user.dutyType ?? "-"}</td>
                                                            <td style={blinkStyle}>
                                                                {userDetails.countryCode ? userDetails.countryCode : user.countryCode}
                                                                {userDetails.mobileNo ? userDetails.mobileNo : user.mobileNo}
                                                            </td>
                                                            <td style={blinkStyle}>
                                                                {sites.find(
                                                                    (site) => site.id === user.site_id
                                                                )?.name ?? "-"}
                                                            </td>
                                                            <td style={blinkStyle}>{formatDateTimeAuto(user.entryTime)}</td>

                                                            {/* ✅ Running / Frozen working time */}
                                                            <td style={blinkStyle}>{formatSeconds(workedSeconds)}</td>

                                                            <td style={blinkStyle}>
                                                                {user.exitTime
                                                                    ? formatDateTimeAuto(user.exitTime)
                                                                    : "-"}
                                                            </td>

                                                            <td style={blinkStyle}>{user.totalHours ?? "-"}</td>

                                                            <td style={blinkStyle}>
                                                                {user.entryMapUrl ? (
                                                                    <a
                                                                        href={user.entryMapUrl}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        View
                                                                    </a>
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </td>

                                                            <td style={blinkStyle}>
                                                                {user.exitMapUrl ? (
                                                                    <a
                                                                        href={user.exitMapUrl}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        View
                                                                    </a>
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </td>

                                                            <td style={blinkStyle}>
                                                                <button
                                                                    className="btn btn-sm btn-primary m-2"
                                                                    onClick={() => handleEdit(userDetails.firstName ? 'normal' : 'floater', user.id)}
                                                                >
                                                                    Edit
                                                                </button>
                                                                <button
                                                                    className="btn btn-outline-danger btn-sm"
                                                                    onClick={() => {
                                                                        setSelectedId(user.id);
                                                                        setDeleteModal(true);
                                                                    }}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={15} className="text-center">
                                                        No Staff present
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                </div>

                            </div>
                        </>

                    ) : (
                        <>
                            {
                                attendanceDetails.length === 0 ||
                                    (
                                        attendanceDetails.length > 0 &&
                                        attendanceDetails[0].exitTime &&
                                        canReCheckIn(attendanceDetails[0].exitTime)
                                    )
                                    ? (
                                        // No attendance yet -> Check In
                                        <div className="card shadow-sm p-3 p-md-4">
                                            <h5 className="mb-3 text-center text-primary fw-bold">
                                                Attendance Check-In
                                            </h5>

                                            <div className="row g-3 align-items-center">
                                                <div className="col-12 col-md-4 text-center text-md-start">
                                                    <small className="text-muted">Date</small>
                                                    <div className="fw-semibold">{date}</div>
                                                </div>

                                                {/* <div className="col-12 col-md-4 text-center text-md-start">
                                                <small className="text-muted">Live Time</small>
                                                <div className="fw-semibold">{time}</div>
                                            </div> */}

                                                <div className="col-12 col-md-4">
                                                    <small className="text-muted">Grade</small>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        value={roleIdByUser}
                                                        onChange={(e) => {
                                                            const selectedRoleId = e.target.value;
                                                            const selectedRole = roles.find(
                                                                (role) => role.id == selectedRoleId
                                                            );

                                                            setRoleIdByUser(selectedRoleId);
                                                            // setDutyName(selectedRole ? selectedRole.name : "");
                                                        }}
                                                    >

                                                        <option value="">Select Grade</option>
                                                        {roles.length > 0 ? (
                                                            roles.map((role) => (
                                                                <option key={role.id} value={role.id}>
                                                                    {role.name}
                                                                </option>
                                                            ))
                                                        ) : (
                                                            <option value="">No Grades Found</option>
                                                        )}
                                                    </select>
                                                </div>

                                                <div className="col-12 col-md-4">
                                                    <small className="text-muted">Duty</small>
                                                    <select
                                                        className="form-select form-select-sm"
                                                        value={dutyTypeId}
                                                        onChange={(e) => {
                                                            const selectedId = e.target.value;
                                                            const selectedDuty = dutyTypes.find(
                                                                (d) => d.id == selectedId
                                                            );

                                                            setDutyTypeId(selectedId);
                                                            // setDutyName(selectedDuty ? selectedDuty.duty : "");
                                                        }}
                                                    >

                                                        <option value="">Select Duty</option>
                                                        {dutyTypes.length > 0 ? (
                                                            dutyTypes.map((duty) => (
                                                                <option key={duty.id} value={duty.id}>
                                                                    {duty.duty}
                                                                </option>
                                                            ))
                                                        ) : (
                                                            <option value="">No Duties Found</option>
                                                        )}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="text-center mt-4">
                                                <button
                                                    className="btn btn-success btn-sm w-100 w-md-auto px-5"
                                                    onClick={handleCheckIn}
                                                    disabled={loading}
                                                >
                                                    {loading ? "Checking In..." : "Check In"}
                                                </button>
                                            </div>
                                        </div>


                                    ) : (

                                        !attendanceDetails[0].exitTime ? (
                                            // Attendance exists but not checked out -> Show Check Out
                                            <div className="card shadow p-4">
                                                <h4 className="mb-4 text-center text-primary">Attendance Check-Out</h4>
                                                <div className="row mb-3">
                                                    <div className="col-md-3"><strong>Date:</strong> {date}</div>
                                                    {/* <div className="col-md-3"><strong>Live Time:</strong> {time}</div> */}
                                                    <div className="col-md-3"><strong>Grade:</strong> {attendanceDetails[0].roleDetails[0].name}</div>
                                                    <div className="col-md-3"><strong>Duty Type:</strong> {attendanceDetails[0].dutyType}</div>

                                                </div>
                                                <div className="row mb-3">
                                                    {/* <div className="col-md-3"><strong>Entry Time:</strong> {formatTime(attendanceDetails[0].entryTime)}</div> */}
                                                    <div className="col-md-3"><strong>Entry Time:</strong> {formatDateTimeAuto(attendanceDetails[0].entryTime)}</div>
                                                    <div className="col-md-3"><strong>Working Hours:</strong> {workingTime}</div>
                                                </div>
                                                <div className="text-center mt-3">
                                                    <button
                                                        className="btn btn-danger btn-lg px-5"
                                                        onClick={() => handleCheckOut(attendanceDetails[0].id)}
                                                        disabled={loading}
                                                    >
                                                        {loading ? 'Checking Out...' : 'Check Out'}
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            // Attendance exists and checked out -> Show Working Details
                                            <div className="card shadow p-4">
                                                <h4 className="mb-4 text-center text-primary">Working Details</h4>
                                                <div className="row mb-3">
                                                    <div className="col-md-4"><strong>Date:</strong> {date}</div>
                                                    <div className="col-md-4"><strong>Grade:</strong> {attendanceDetails[0].roleDetails[0].name}</div>
                                                    <div className="col-md-4"><strong>Duty Type:</strong> {attendanceDetails[0].dutyType}</div>
                                                    {/* <div className="col-md-6"><strong>Entry Time:</strong> {formatTime(attendanceDetails[0].entryTime)}</div> */}

                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-md-4"><strong>Entry Time:</strong> {formatDateTimeAuto(attendanceDetails[0].entryTime)}</div>
                                                    <div className="col-md-4"><strong>Exit Time:</strong> {formatDateTimeAuto(attendanceDetails[0].exitTime)}</div>
                                                </div>
                                                <div className="row mb-3">
                                                    <div className="col-md-6"><strong>Total Working Hours:</strong> {calculateWorkingHours(attendanceDetails[0].entryTime, attendanceDetails[0].exitTime)}</div>
                                                </div>
                                            </div>
                                        )
                                    )}
                        </>
                    )}
                    {deleteModal && (
                        <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>Delete ?</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                Are you sure you want to Delete?
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setDeleteModal(false)}>
                                    Cancel
                                </Button>
                                <Button variant="danger" onClick={() => handleDeleteConfirm(selectedId)}>
                                    Delete
                                </Button>
                            </Modal.Footer>
                        </Modal>

                    )}
                </>

            }

        </div>
    );
};


export default Attendance;
